import { Action, createReducer, on } from '@ngrx/store';
import { CustomerState } from './customer.state';

import * as customerActions from '@store/customer/customer.actions';

export const initialCustomer: CustomerState = {
  customer: null,
  isLoading: false,
  preLoan: null,
  redirectUrl: null,
  error: false,
  validation: null,
  id: null,
  isLoadingPreLoan: false,
  cardInfo: null,
  score: null,
  aggregatorValidation: null,
  maxInstallmentValidation: null,
  debitDecisionValidation: null,
};

const _customerReducer = createReducer(
  initialCustomer,
  on(customerActions.requestCustomerInformation, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(customerActions.successRequestCustomerInformation, (state, { customer }) => {
    return {
      ...state,
      isLoading: false,
      customer,
    };
  }),
  on(customerActions.failureRequestCustomerInformation, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  }),
  on(customerActions.listenCustomerValidation, (state) => {
    return {
      ...state,
      isLoading: true,
      error: false,
    };
  }),
  on(customerActions.successListenCustomerValidation, (state, { validation }) => {
    return {
      ...state,
      isLoading: false,
      validation,
      error: false,
    };
  }),
  on(customerActions.failureListenCustomerValidation, (state) => {
    return {
      ...state,
      isLoading: false,
      error: true,
    };
  }),
  on(customerActions.setCustomerInformation, (state, { customer }) => {
    return {
      ...state,
      isLoading: false,
      customer,
    };
  }),
  on(customerActions.requestPreLoan, (state) => {
    return {
      ...state,
      isLoading: true,
      error: false,
    };
  }),
  on(customerActions.successRequestPreLoan, (state, { preLoan }) => {
    return {
      ...state,
      isLoading: false,
      preLoan,
      error: false,
    };
  }),
  on(customerActions.failureRequestPreLoan, (state) => {
    return {
      ...state,
      isLoading: false,
      error: true,
    };
  }),
  on(customerActions.createPreLoan, (state) => {
    return {
      ...state,
      isLoadingPreLoan: true,
      error: false,
    };
  }),
  on(customerActions.successCreatePreLoan, (state, { id }) => {
    return {
      ...state,
      id,
      error: false,
    };
  }),
  on(customerActions.updateIsLoadingPreLoan, (state, { isLoadingPreLoan }) => {
    return {
      ...state,
      isLoadingPreLoan,
    };
  }),
  on(customerActions.failureCreatePreLoan, (state) => {
    return {
      ...state,
      isLoadingPreLoan: false,
      error: true,
    };
  }),
  on(customerActions.getCustomerCard, (state) => {
    return {
      ...state,
      isLoading: true,
      error: false,
    };
  }),
  on(customerActions.successGetCustomerCard, (state, { cardInfo }) => {
    return {
      ...state,
      cardInfo,
      isLoading: false,
      error: false,
    };
  }),
  on(customerActions.failureGetCustomerCard, (state) => {
    return {
      ...state,
      isLoading: false,
      error: false,
    };
  }),
  on(customerActions.setCustomerValidation, (state, { validation }) => {
    return {
      ...state,
      validation,
    };
  }),
  on(customerActions.requestAvailableScore, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(customerActions.successRequestAvailableScore, (state, { score }) => {
    return {
      ...state,
      isLoading: false,
      score,
    };
  }),
  on(customerActions.failureRequestAvailableScore, (state) => {
    return {
      ...state,
      isLoading: false,
      error: true,
    };
  }),
  on(customerActions.requestCustomerScore, (state) => {
    return {
      ...state,
      isLoadingPayments: true,
    };
  }),
  on(customerActions.successRequestCustomerScore, (state, { score }) => {
    return {
      ...state,
      isLoadingPayments: true,
      score,
    };
  }),
  on(customerActions.failureRequestCustomerScore, (state) => {
    return {
      ...state,
      isLoadingPayments: false,
      error: true,
    };
  }),
  on(customerActions.requestAggregatorValidation, (state) => {
    return {
      ...state,
      isLoading: true,
      error: false,
    };
  }),
  on(customerActions.successRequestAggregatorValidation, (state, { aggregatorValidation }) => {
    return {
      ...state,
      isLoading: false,
      error: false,
      aggregatorValidation,
    };
  }),
  on(customerActions.failureRequestAggregatorValidation, (state) => {
    return {
      ...state,
      isLoading: false,
      error: true,
    };
  }),
  on(customerActions.requestMaxInstallmentValidation, (state) => {
    return {
      ...state,
      isLoading: true,
      error: false,
    };
  }),
  on(
    customerActions.successRequestMaxInstallmentValidation,
    (state, { maxInstallmentValidation }) => {
      return {
        ...state,
        isLoading: false,
        error: false,
        maxInstallmentValidation,
      };
    }
  ),
  on(customerActions.failureRequestMaxInstallmentValidation, (state) => {
    return {
      ...state,
      isLoading: false,
      error: true,
    };
  }),
  on(customerActions.requestDebitDecisionValidation, (state) => {
    return {
      ...state,
      isLoading: true,
      error: false,
    };
  }),
  on(
    customerActions.successRequestDebitDecisionValidation,
    (state, { debitDecisionValidation }) => {
      return {
        ...state,
        isLoading: false,
        error: false,
        debitDecisionValidation,
      };
    }
  ),
  on(customerActions.failureRequestMaxInstallmentValidation, (state) => {
    return {
      ...state,
      isLoading: false,
      error: true,
    };
  })
);

export function customerReducers(state: CustomerState | undefined, action: Action) {
  return _customerReducer(state, action);
}
